import { sidePanelWidth, versions } from "../../util/constants";
import { ControlPanel } from "../ControlPanel/ControlPanel";
import { HotspotLocationEditorWithBottomPanel } from "../HotspotLocationEditorWithBottomPanel/HotspotLocationEditorWithBottomPanel";
import { HelpButton } from "../HelpButton/HelpButton";
import { getVersion } from "../../util/getVersion";

export function HotspotEditor({ style }) {
  const version = getVersion();
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        width: "100vw",
        maxHeight: "100%",
        boxSizing: "border-box",
        ...style,
      }}
    >
      <HotspotLocationEditorWithBottomPanel
        style={{
          flex: "1 1 0",
        }}
      />
      <ControlPanel
        style={{
          flex: `0 0 ${sidePanelWidth}}`,
          width: sidePanelWidth,
        }}
      />
      {version === versions.spin ? (
        <HelpButton
          style={{
            position: "absolute",
            right: "1rem",
            bottom: "10px",
          }}
        />
      ) : null}
    </div>
  );
}
